module.exports = __webpack_public_path__ + "static/img/jieshu2.7c62628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jieshu2.png
// module id = eC06
// module chunks = 24